import { createRoot } from "react-dom/client";
import { LabFixForm } from "../../lab_fix/LabFixForm";

export const initLabFixForm = () => {
  const labFixFormContainer = document.getElementById("lab_fix");

  if (labFixFormContainer) {
    const root = createRoot(labFixFormContainer);
    const { case: caseData, saveUrl, initialTestOptions, initialIcd10CodeOptions, caseInMissingInfo, labId } = labFixFormContainer.dataset;

    root.render(
      <LabFixForm
        saveUrl={saveUrl}
        initialCaseData={JSON.parse(caseData)}
        caseInMissingInfo={JSON.parse(caseInMissingInfo)}
        initialIcd10CodeOptions={JSON.parse(initialIcd10CodeOptions)}
        initialTestOptions={JSON.parse(initialTestOptions)}
        labId={JSON.parse(labId)}
      />
    );
  }
};
